import {
  cn
} from "./chunk-LJ5F4WFH.js";

// src/Separator/Separator.tsx
import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
var Separator = React.forwardRef(
  ({ className, orientation = "horizontal", decorative = true, ...props }, ref) => /* @__PURE__ */ React.createElement(
    SeparatorPrimitive.Root,
    {
      ref,
      decorative,
      orientation,
      className: cn(
        "shrink-0 bg-surface-medium",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className
      ),
      ...props
    }
  )
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export {
  Separator
};
//# sourceMappingURL=chunk-K4FH7D5T.js.map